import { Selector } from '@ngxs/store';
import { SubscriptionStateModel } from './subscription.models';
import { SubscriptionState } from './subscription.state';

export class SubscriptionSelectors {
  @Selector([SubscriptionState])
  static hasSubscriptionCards(state: SubscriptionStateModel): boolean {
    return state.hasSubscriptionCards;
  }

  @Selector([SubscriptionState])
  static hasAccounting(state: SubscriptionStateModel): boolean | undefined {
    return state.hasAccounting;
  }

  @Selector([SubscriptionState])
  static hasCurrentSubscriptionData(state: SubscriptionStateModel): boolean {
    return state.hasCurrentSubscriptionData;
  }
}
